'use strict';

exports.__esModule = true;
exports.SubBarDropdown = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _dropdown = require('dropdown');

require('../../src/styles/external.scss');

var _style = require('../../src/styles/style.scss');

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//flow
var SubBarDropdown = exports.SubBarDropdown = function SubBarDropdown(props) {
	return _react2.default.createElement(
		'div',
		{ className: props.className + ' ' + _style2.default.subBarDropdownHolder },
		_react2.default.createElement(_dropdown.Dropdown, {
			className: _style2.default.SubBarDropdown,
			items: props.items,
			placeholder: props.placeholder,
			readonly: 'true',
			selectedItem: props.selectedItem,
			onItemSelected: props.onItemSelected,
			ContentRenderer: function ContentRenderer() {
				return _react2.default.createElement(
					'div',
					{ className: _style2.default.dropdownContentRenderer },
					_react2.default.createElement('i', { className: props.icon + ' ' + _style2.default.black + ' ' + _style2.default.small }),
					_react2.default.createElement('i', { className: _style2.default.black + ' ' + _style2.default.medium + ' ion-android-arrow-dropdown' })
				);
			},
			ItemRenderer: function ItemRenderer(list) {
				return _react2.default.createElement(
					'div',
					{ className: _style2.default.dropdownItemNoIcon },
					_react2.default.createElement(
						'span',
						null,
						list.item.name
					)
				);
			} })
	);
};

SubBarDropdown.propTypes = {
	className: require('react').PropTypes.any,
	items: require('react').PropTypes.arrayOf(require('react').PropTypes.object),
	placeholder: require('react').PropTypes.any,
	icon: require('react').PropTypes.any,
	onItemSelected: require('react').PropTypes.func,
	selectedItem: require('react').PropTypes.object
};
SubBarDropdown.displayName = 'SubBarDropdown';

SubBarDropdown.defaultProps = {
	items: [],
	onItemSelected: function onItemSelected() {}
};


// WEBPACK FOOTER //
// ./components/advanced-search-bar/lib/components/sub-bar-dropdown.js